import {
  Dataset,
  ReferenceControl,
  ReferenceValue,
} from '../../../../../../types/types';
import { isEmptyValue } from '../../../../../../utils/managerUtils';

type IsResolvingLabelOptions = {
  isFormInput: boolean;
  value: ReferenceValue;
  control: ReferenceControl;
  dataset: Dataset | undefined;
}

// No-labelItem reference: the label is the idItem value, which may be a
// dateTime needing formatting. We can't format until the dataset definition
// loads, so show a loading state instead of flashing the raw value.
export const isResolvingLabel = ({
  isFormInput,
  value,
  control,
  dataset,
}: IsResolvingLabelOptions): boolean =>
  isFormInput &&
  !isEmptyValue(value) &&
  (!control.labelItem || control.labelItem === control.idItem) &&
  !dataset;
